<script setup lang="ts">
  import { computed } from "vue";
  import { IconMenuCompass, Text } from "@ui-kit";
  import { useDeviceInfo } from "@plugins";
  import { useProfileOptions } from "@src/hooks";
  import { useWidgetsStore } from "@src/store";
  import { default as MainPageAction } from "./MainPageAction.vue";

  const { deviceInfo } = useDeviceInfo();
  const { hasPermission } = useProfileOptions();
  const widgets_store = useWidgetsStore();

  const is_available_action = computed(() => {
    return hasPermission("mobile.item_list") && (deviceInfo?.value.isRfidReader || deviceInfo?.value.isBarcodeScanner);
  });
</script>

<template>
  <MainPageAction v-if="is_available_action" @click="() => widgets_store.open('zoning')" data-testid="action-zoning">
    <template #icon>
      <IconMenuCompass />
    </template>
    <template #text>
      <Text font="body-regular-18" :wrap="false">{{ $t("Зонирование товара") }}</Text>
    </template>
  </MainPageAction>
</template>
